import Facility from "../facilities/facility";

export default class PatientChartFacilities {
  hasHospiceTransfer: boolean;
  hasPharmacy: boolean;
  hasFuneralHome: boolean;
  facilities: Facility[];
}



// WEBPACK FOOTER //
// ./src/models/patient-chart/patient-chart-facilities.ts